document.querySelectorAll('.js-bundle-step-indicator').forEach((btn) => {
  btn.addEventListener('click', () => activateStep(btn.dataset.step));
});

// The drawer pills double as step navigation at every breakpoint.
const bundleDesktop = window.matchMedia('(min-width: 990px)');
document.querySelectorAll('.js-bundle-drawer-pill').forEach((pill) => {
  pill.addEventListener('click', () => activateStep(pill.dataset.step));
});

function activateStep(step) {
  const allButtons = document.querySelectorAll('.js-bundle-step-indicator');

  allButtons.forEach((btn) => {
    const section = document.querySelector(
      `.js-bundle-step[data-step="${btn.dataset.step}"]`
    );
    const isActive = btn.dataset.step === step;
    btn.dataset.active = isActive ? 'active' : 'inactive';
    section.toggleAttribute('hidden', !isActive);
  });

  const activeSection = document.querySelector(
    `.js-bundle-step[data-step="${step}"]`
  );

  // Offset the scroll by the sticky chrome so the section heading isn't hidden
  // behind it. On mobile that's the header + the sticky stepper strip; on
  // desktop the stepper is a hidden side column, so it's just the header.
  const header = document.querySelector('#shopify-section-header');
  const stepper = document.querySelector('.js-bundle-stepper');
  const stepperHeight = bundleDesktop.matches ? 0 : stepper.offsetHeight;
  const offset = header.offsetHeight + stepperHeight;

  // Absolute document position of the section top, minus the sticky offset.
  const top =
    activeSection.getBoundingClientRect().top + window.scrollY - offset;

  window.scrollTo({ top, behavior: 'smooth' });

  // The drawer pill subscriber listens for this to flip its active state.
  document.dispatchEvent(
    new CustomEvent('build-a-bundle:step-changed', { detail: { step } })
  );
}

/* Stepper state subscriber — updates each indicator's data-state when
   the bundle changes. data-active is owned by the click handler above. */

// Empty required step → 'required'; empty addons → 'optional'; any step
// with items → 'added'.
const REQUIRED_STEPS = ['harnesses', 'dildos'];

// The data-state value for one step, given whether it currently has items.
function computeState(step, hasItems) {
  if (hasItems) return 'added';
  return REQUIRED_STEPS.includes(step) ? 'required' : 'optional';
}

// Recompute data-state for every step indicator from current bundle state.
function syncStepperState() {
  const bundleState = window.BuildABundleState.getState();
  document
    .querySelectorAll('.js-bundle-step-indicator')
    .forEach((indicator) => {
      const step = indicator.dataset.step;
      const items = bundleState[step] || [];
      indicator.dataset.state = computeState(step, items.length > 0);
    });
}

// Paint from current state and subscribe. If the state module isn't up
// yet, wait for its hydrated event first.
function initStepperStateSubscriber() {
  if (window.BuildABundleState) {
    syncStepperState();
    window.BuildABundleState.subscribe(
      'build-a-bundle:state-changed',
      syncStepperState
    );
  } else {
    document.addEventListener(
      'build-a-bundle:hydrated',
      () => {
        syncStepperState();
        window.BuildABundleState.subscribe(
          'build-a-bundle:state-changed',
          syncStepperState
        );
      },
      { once: true }
    );
  }
}

initStepperStateSubscriber();

/* Build a Bundle — product cards */

// Step order drives the auto-advance after an item is added to the bundle.
const BUNDLE_STEP_ORDER = ['harnesses', 'dildos', 'addons'];

// Cosmetic Add-button timings — match the site's quick-add pattern.
const BUNDLE_ADDING_MS = 350;
const BUNDLE_ADDED_MS = 800;

function initBundleCard(card) {
  const dataEl = card.querySelector('.js-bundle-card-data');
  if (!dataEl) return;

  let variants;
  try {
    variants = JSON.parse(dataEl.textContent).variants;
  } catch (error) {
    console.error('[build-a-bundle] could not parse card data', error, card);
    return;
  }

  const swatches = card.querySelectorAll('.js-bundle-card-swatch');
  const sizeSelect = card.querySelector('.js-bundle-card-select');
  const addButton = card.querySelector('.js-bundle-card-add');
  const imageEl = card.querySelector('.js-bundle-card-image');
  const priceEl = card.querySelector('.js-bundle-card-price');

  // The variant matching the currently-selected colour swatch + size option.
  function getSelectedVariant() {
    const selectedSwatch = card.querySelector(
      '.js-bundle-card-swatch.is-selected'
    );
    const color = selectedSwatch ? selectedSwatch.dataset.color : null;
    const size = sizeSelect ? sizeSelect.value : null;
    return variants.find(
      (v) =>
        (color === null || v.color === color) &&
        (size === null || v.size === size)
    );
  }

  // Sync the price block + image to a variant.
  function renderVariant(variant) {
    if (!variant) return;
    if (priceEl) {
      const onSale = variant.compareAt > variant.price;
      priceEl.classList.toggle('build-a-bundle__card-price--on-sale', onSale);
      const saleEl = priceEl.querySelector('.js-bundle-card-price-sale');
      const compareEl = priceEl.querySelector('.js-bundle-card-price-compare');
      if (saleEl) saleEl.innerHTML = variant.priceMoney;
      if (compareEl) compareEl.innerHTML = variant.compareAtMoney;
    }
    if (imageEl && variant.image) imageEl.src = variant.image;
  }

  // Disable size options with no in-stock variant for the chosen colour,
  // then re-point the dropdown if its value just became unavailable.
  function refreshSizeOptions() {
    if (!sizeSelect) return;
    const selectedSwatch = card.querySelector(
      '.js-bundle-card-swatch.is-selected'
    );
    const color = selectedSwatch ? selectedSwatch.dataset.color : null;
    let selectedStillValid = false;

    Array.from(sizeSelect.options).forEach((option) => {
      const match = variants.find(
        (v) => v.size === option.value && (color === null || v.color === color)
      );
      const available = Boolean(match && match.available);
      option.disabled = !available;
      if (option.selected && available) selectedStillValid = true;
    });

    if (!selectedStillValid) {
      const firstAvailable = Array.from(sizeSelect.options).find(
        (option) => !option.disabled
      );
      if (firstAvailable) sizeSelect.value = firstAvailable.value;
    }
  }

  swatches.forEach((swatch) => {
    swatch.addEventListener('click', () => {
      if (swatch.disabled) return;
      swatches.forEach((s) => s.classList.remove('is-selected'));
      swatch.classList.add('is-selected');
      refreshSizeOptions();
      renderVariant(getSelectedVariant());
    });
  });

  if (sizeSelect) {
    sizeSelect.addEventListener('change', () =>
      renderVariant(getSelectedVariant())
    );
  }

  if (addButton) {
    addButton.addEventListener('click', () =>
      addBundleCardItem(card, getSelectedVariant(), addButton)
    );
  }

  // Details click is handled by build-a-bundle-quickview.js via delegation.

  // Initial sync: set size availability for the starting colour, then make
  // sure the price/image reflect whatever variant ends up selected.
  refreshSizeOptions();
  renderVariant(getSelectedVariant());
}

// Add the selected variant to the bundle, run the Adding -> Added button
// states, revert to default, then advance to the next step.
function addBundleCardItem(card, variant, button) {
  if (!variant || !variant.available || button.disabled) return;

  const grid = card.closest('.js-bundle-grid');
  const step = grid ? grid.dataset.step : null;

  setBundleAddButtonState(button, 'adding');

  window.setTimeout(() => {
    if (window.BuildABundleState) {
      window.BuildABundleState.addItem(step, {
        variantId: variant.id,
        productId: card.dataset.productId,
        price: variant.price,
        compareAtPrice: variant.compareAt,
        title: card
          .querySelector('.build-a-bundle__card-title')
          .textContent.trim(),
        image: variant.image,
        size: variant.size,
        color: variant.color,
      });
    }

    setBundleAddButtonState(button, 'added');

    window.setTimeout(() => {
      setBundleAddButtonState(button, 'default');
      advanceBundleStep(step);
    }, BUNDLE_ADDED_MS);
  }, BUNDLE_ADDING_MS);
}

// Swap the Add button between its default / adding / added states.
function setBundleAddButtonState(button, state) {
  button.classList.remove('is-loading', 'is-added');
  if (!button.dataset.originalHtml) {
    button.dataset.originalHtml = button.innerHTML;
  }

  switch (state) {
    case 'adding':
      button.classList.add('is-loading');
      button.disabled = true;
      button.innerHTML =
        '<span class="build-a-bundle__card-add-label">' +
        button.dataset.addingLabel +
        '</span>';
      break;
    case 'added':
      button.classList.add('is-added');
      button.disabled = true;
      button.innerHTML =
        '<span class="build-a-bundle__card-add-label">' +
        button.dataset.addedLabel +
        '</span>';
      break;
    case 'default':
      button.disabled = false;
      button.innerHTML = button.dataset.originalHtml;
      break;
  }
}

// Move the builder to the step after the given one (no-op on the last step).
function advanceBundleStep(step) {
  const index = BUNDLE_STEP_ORDER.indexOf(step);
  if (index === -1 || index === BUNDLE_STEP_ORDER.length - 1) return;
  activateStep(BUNDLE_STEP_ORDER[index + 1]);
}

document.querySelectorAll('.js-bundle-card').forEach(initBundleCard);
